import React, { useState, useEffect, useMemo } from "react";
import { Form } from "@tencent/universe-ui/build/lib";
import { Button } from 'tdesign-react';
import { MathJax } from "better-react-mathjax";

// 批改结果加载中组件
const MarkLoadingCom = ({ msg = '识别中...' }) => {
  return (
    <div className="ocrDemo-resulting-container">
      <div className="ocrDemo-icon-resulting"></div>
      <div className="ocrDemo-resulting__text">{msg}</div>
    </div>
  );
};

// 答案列表组件
function AnswerList({ answers, keyPrefix, onSelect, selectRect, collList, setCollList }) {
  if (!answers || answers.length === 0) return null;

  if (answers.length === 1) {
    // 只有一个答案时，直接平铺数据，不展示折叠
    const answer = answers[0];
    const answerKey = `${keyPrefix}_0`;
    return (
      <div>
        {answer.HandwriteInfo && (
          <Form.Item 
            label="手写答案"
            onClick={() => {
              onSelect && onSelect(answerKey)
            }}
            style={{ cursor: 'pointer' }}
          >
            <div className="edu_form__item" style={{ color: selectRect === answerKey ? '#006eff' : 'inherit' }}>
              {answer.HandwriteInfo && (
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {answer.HandwriteInfo}
                </MathJax>
              )}
            </div>
          </Form.Item>
        )}
        {answer.IsCorrect !== undefined && (
          <Form.Item label="答案判断">
            <div className="edu_form__item" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <span className={`edu-correct-icon small ${answer.IsCorrect ? 'correct' : 'error'}`}></span>
              <span>{answer.IsCorrect ? '正确' : '错误'}</span>
            </div>
          </Form.Item>
        )}
        {answer.RightAnswer && (
          <Form.Item label="正确答案">
            <div className="edu_form__item">
              {answer.RightAnswer && (
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {answer.RightAnswer}
                </MathJax>
              )}
            </div>
          </Form.Item>
        )}

        {answer.KnowledgePoints && answer.KnowledgePoints.length > 0 && (
          <Form.Item label="知识点">
            <div className="edu_form__item" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {answer.KnowledgePoints.map((point, idx) => (
                <span key={idx} style={{
                  padding: '2px 8px',
                  background: '#f0f5ff',
                  borderRadius: '4px',
                  color: '#4A70ff',
                  fontSize: '12px'
                }}>{point}</span>
              ))}
            </div>
          </Form.Item>
        )}

        {answer.AnswerAnalysis && (
          <Form.Item label="答案分析">
            <div className="edu_form__item">
              {answer.AnswerAnalysis && (
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {answer.AnswerAnalysis}
                </MathJax>
              )}
            </div>
          </Form.Item>
        )}
      </div>
    );
  }

  // 多个答案时，展示可折叠的答案项
  return answers.map((answer, answerIdx) => {
    const answerKey = `${keyPrefix}_${answerIdx}`;
    const collKey = `answer_${keyPrefix}_${answerIdx}`;
    
    const handleTitleClick = () => {
      // 同时触发 select 和折叠
      onSelect && onSelect(answerKey);
      let _collList = [...collList];
      if (_collList.includes(collKey)) {
        _collList.splice(_collList.indexOf(collKey), 1);
      } else {
        _collList.push(collKey);
      }
      setCollList(_collList);
    };
    
    return (
      <div
        key={answerIdx}
        className={`isSub ${collList.includes(collKey) ? 'isHide' : 'isActive'} edu_container__item edu_container__item--small`}
      >
        <div 
          className="edu_title_container edu_title_container--small" 
          onClick={handleTitleClick}
        >
          <span className="edu_title__text">答案{answerIdx + 1}</span>
          <span className="edu_title__collaps">
            <svg width="12" height="12" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.77971 9L7.00005 6.33766L4.22039 9L3.0001 7.83117L7.00005 4L11 7.83117L9.77971 9Z" fill="#32394B" />
            </svg>
          </span>
        </div>
        <div className="edu_body_container">
          {answer.HandwriteInfo && (
            <Form.Item 
              label="手写答案"
              onClick={() => {
                onSelect && onSelect(answerKey)
              }}
              style={{ cursor: 'pointer' }}
            >
              <div className="edu_form__item" style={{ color: selectRect === answerKey ? '#006eff' : 'inherit' }}>
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {answer.HandwriteInfo}
                </MathJax>
              </div>
            </Form.Item>
          )}

          {answer.IsCorrect !== undefined && (
            <Form.Item label="答案判断">
              <div className="edu_form__item" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                <span className={`edu-correct-icon small ${answer.IsCorrect ? 'correct' : 'error'}`}></span>
                <span>{answer.IsCorrect ? '正确' : '错误'}</span>
              </div>
            </Form.Item>
          )}

          {answer.RightAnswer && (
            <Form.Item label="正确答案">
              <div className="edu_form__item">
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {answer.RightAnswer}
                </MathJax>
              </div>
            </Form.Item>
          )}

          {answer.KnowledgePoints && answer.KnowledgePoints.length > 0 && (
            <Form.Item label="知识点">
              <div className="edu_form__item" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {answer.KnowledgePoints.map((point, idx) => (
                  <span key={idx} style={{
                    padding: '2px 8px',
                    background: '#f0f5ff',
                    borderRadius: '4px',
                    color: '#4A70ff',
                    fontSize: '12px'
                  }}>{point}</span>
                ))}
              </div>
            </Form.Item>
          )}

          {answer.AnswerAnalysis && (
            <Form.Item label="答案分析">
              <div className="edu_form__item">
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {answer.AnswerAnalysis}
                </MathJax>
              </div>
            </Form.Item>
          )}
        </div>
      </div>
    );
  });
}

// 子题目组件
function SubQuestionList({ subMarkInfos, questionIdx, onSelect, selectRect, collList, setCollList }) {
  if (!subMarkInfos || subMarkInfos.length === 0) return null;

  if (subMarkInfos.length === 1) {
    // 只有一个子题目时，不折叠，直接展示
    const subMark = subMarkInfos[0];
    const subKey = `markInfo${questionIdx}_sub0`;
    return (
      <div style={{ marginTop: '8px' }}>
        {subMark.MarkItemTitle && (
          <Form.Item label="子题题干">
            <div className="edu_form__item">
              <MathJax dynamic hideUntilTypeset={"first"}>
                {subMark.MarkItemTitle}
              </MathJax>
            </div>
          </Form.Item>
        )}
        <AnswerList 
          answers={subMark.AnswerInfos}
          keyPrefix={subKey}
          onSelect={onSelect}
          selectRect={selectRect}
          collList={collList}
          setCollList={setCollList}
        />
      </div>
    );
  }

  // 多个子题目时，展示可折叠的子题目
  return subMarkInfos.map((subMark, subIdx) => {
    const subKey = `markInfo${questionIdx}_sub${subIdx}`;
    const collKey = `sub_${questionIdx}_${subIdx}`;
    
    const handleTitleClick = () => {
      // 同时触发 select 和折叠
      onSelect && onSelect(subKey);
      let _collList = [...collList];
      if (_collList.includes(collKey)) {
        _collList.splice(_collList.indexOf(collKey), 1);
      } else {
        _collList.push(collKey);
      }
      setCollList(_collList);
    };
    
    return (
      <div
        key={subIdx}
        className={`isSub ${collList.includes(collKey) ? 'isHide' : 'isActive'} edu_container__item`}
        style={{ marginTop: '8px' }}
      >
        <div 
          className="edu_title_container" 
          onClick={handleTitleClick}
        >
          <span className="edu_title__tips"></span>
          <span className="edu_title__text">子题目{subIdx + 1}</span>
          <span className="edu_title__collaps">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.77971 9L7.00005 6.33766L4.22039 9L3.0001 7.83117L7.00005 4L11 7.83117L9.77971 9Z" fill="#32394B" />
            </svg>
          </span>
        </div>
        <div className="edu_body_container">
          {subMark.MarkItemTitle && (
            <Form.Item label="子题题干">
              <div className="edu_form__item">
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {subMark.MarkItemTitle}
                </MathJax>
              </div>
            </Form.Item>
          )}
          <AnswerList 
            answers={subMark.AnswerInfos}
            keyPrefix={subKey}
            onSelect={onSelect}
            selectRect={selectRect}
            collList={collList}
            setCollList={setCollList}
          />
        </div>
      </div>
    );
  });
}

function EduMarkCom({ questionInfo = [], markInfos = [], rects = [], onSelect, selectRect, isMarkLoading = false }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [collList, setCollList] = useState([]);
  // 用于标记是否是内部触发的 selectRect 变更，避免循环
  const [internalSelect, setInternalSelect] = useState(false);

  // 将markInfos按数组顺序对应到questionInfo上
  const questionsWithMark = useMemo(() => {
    // 如果有 questionInfo，按数组顺序关联
    if (questionInfo && questionInfo.length > 0) {
      return questionInfo.map((question, index) => {
        return {
          ...question,
          markData: markInfos[index] || null
        };
      });
    }
    
    // 如果没有 questionInfo，根据 markInfos 生成题目信息
    if (markInfos && markInfos.length > 0) {
      return markInfos.map((markInfo, index) => {
        return {
          QuestionIndex: index,
          QuestionTitle: markInfo.MarkItemTitle || `题目${index + 1}`,
          markData: markInfo
        };
      });
    }
    
    return [];
  }, [questionInfo, markInfos]);

  // 当前选中的题目
  const currentQuestion = questionsWithMark[currentIndex] || {};
  const currentMark = currentQuestion.markData || {};
  const { MarkItemTitle, AnswerInfos = [], MarkInfos: SubMarkInfos = [] } = currentMark;

  // 内部触发 onSelect 的封装函数
  const handleInternalSelect = (key) => {
    setInternalSelect(true);
    onSelect && onSelect(key);
  };

  // 判断题目是否有对应的markInfo
  const hasMarkData = (index) => {
    return questionsWithMark[index]?.markData !== null;
  };

  // questionInfo首次渲染成功时，默认选中第一个rect
  useEffect(() => {
    if (questionsWithMark.length > 0) {
      handleInternalSelect('Question01');
    }
  }, [questionsWithMark.length > 0]);

  // 监听selectRect变化，切换到对应的题目（仅处理外部变更）
  useEffect(() => {
    if (!selectRect) return;
    console.log('selectRect',selectRect)
    
    // 如果是内部触发的变更，跳过处理并重置标记
    if (internalSelect) {
      setInternalSelect(false);
      return;
    }
    
    // 解析selectRect，提取题目索引
    // 支持格式：Question01, Question111, markInfo0_0, markInfo0_sub0_0 等
    let questionIdx = null;
    
    if (selectRect.startsWith('Question')) {
      // Question01 -> index 0, Question11 -> index 1, Question111 -> index 11
      // 格式为 Question + index + 1（固定后缀），去掉最后一个字符后取数字
      const withoutSuffix = selectRect.slice(8, -1); // 去掉 "Question" 和最后的 "1"
      if (withoutSuffix && /^\d+$/.test(withoutSuffix)) {
        questionIdx = parseInt(withoutSuffix, 10);
      }
    } else if (selectRect.startsWith('markInfo')) {
      // markInfo0_0, markInfo0_sub0_0 等
      const match = selectRect.match(/markInfo(\d+)/);
      if (match) {
        questionIdx = parseInt(match[1], 10);
      }
    }
    
    // 如果解析出有效的题目索引，且与当前不同，则切换
    if (questionIdx !== null && questionIdx > -1 &&  questionIdx !== currentIndex && hasMarkData(questionIdx)) {
      setCurrentIndex(questionIdx);
    }
  }, [selectRect]);

  // 统计错误数量（只统计有markData的题目）
  const { totalQuestions, wrongQuestionCount, wrongSubQuestionCount } = useMemo(() => {
    const total = questionsWithMark.filter(q => q.markData).length;
    let wrongQuestion = 0;
    let wrongSubQuestion = 0;
    
    // 递归统计所有 IsCorrect: false 的答案数量
    const countWrongAnswers = (markInfo) => {
      let count = 0;
      // 统计当前层级的 AnswerInfos
      const answers = markInfo.AnswerInfos || [];
      answers.forEach(a => {
        if (a.IsCorrect === false) {
          count++;
        }
      });
      // 递归统计子层级的 MarkInfos
      const subMarkInfos = markInfo.MarkInfos || [];
      subMarkInfos.forEach(subMark => {
        count += countWrongAnswers(subMark);
      });
      return count;
    };
    
    questionsWithMark.forEach(question => {
      if (!question.markData) return;
      const wrongCount = countWrongAnswers(question.markData);
      if (wrongCount > 0) {
        wrongQuestion++;
      }
      wrongSubQuestion += wrongCount;
    });
    
    return {
      totalQuestions: total,
      wrongQuestionCount: wrongQuestion,
      wrongSubQuestionCount: wrongSubQuestion
    };
  }, [questionsWithMark]);

  return (
    <div className="edu_container">
      {/* 统计提示文案 - 只在非加载状态且有数据时显示 */}
      {!isMarkLoading && totalQuestions > 0 && (
        <div style={{
          marginBottom: '16px',
          padding: '12px 16px',
          borderRadius: '8px',
          background: 'linear-gradient(93.26deg, #EBF2FF 0.79%, #F7FAFF 21.4%)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px'
        }}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 1C4.13 1 1 4.13 1 8C1 11.87 4.13 15 8 15C11.87 15 15 11.87 15 8C15 4.13 11.87 1 8 1ZM8 13.5C4.97 13.5 2.5 11.03 2.5 8C2.5 4.97 4.97 2.5 8 2.5C11.03 2.5 13.5 4.97 13.5 8C13.5 11.03 11.03 13.5 8 13.5Z" fill="#1890ff"/>
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#1890ff"/>
            <path d="M7.25 5H8.75V8H7.25V5Z" fill="#1890ff"/>
          </svg>
          <span style={{
            fontSize: '14px',
            color: '#333',
            fontWeight: 500
          }}>
            总共解析 <strong style={{ color: '#4A70ff' }}>{totalQuestions}</strong> 道大题
            {wrongQuestionCount > 0 ? (
              <>，其中有 <strong style={{ color: '#4A70ff' }}>{wrongSubQuestionCount}</strong> 道小题错误</>
            ) : (
              <>，全部正确</>
            )}
          </span>
        </div>
      )}

      {/* 题目切换按钮 - 根据questionInfo生成 */}
      <div className="edu_mark_tabs" style={{ marginBottom: '16px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
        {questionsWithMark.map((question, index) => {
          const hasMark = hasMarkData(index);
          return (
            <Button
              key={index}
              variant={currentIndex === index ? 'base' : 'outline'}
              theme={currentIndex === index ? 'primary' : 'default'}
              disabled={!hasMark}
              onClick={() => {
                if (hasMark) {
                  setCurrentIndex(index);
                  handleInternalSelect(`Question${index}1`);
                }
              }}
              style={{
                opacity: hasMark ? 1 : 0.5,
                cursor: hasMark ? 'pointer' : 'not-allowed'
              }}
            >
              题目{index + 1}
            </Button>
          );
        })}
      </div>

      {/* 批改结果加载中 */}
      {isMarkLoading && (questionsWithMark.length === 0 || !hasMarkData(currentIndex)) && (
        <MarkLoadingCom msg="识别中..." />
      )}

      {/* 题目内容 - 非加载状态时显示 */}
      {hasMarkData(currentIndex) && (
        <div className="edu_body_container">
          {/* 大题题干 */}
          {MarkItemTitle && (
            <Form.Item
              label="大题题干"
              onClick={() => handleInternalSelect(`Question${currentIndex}1`)}
              style={{ cursor: 'pointer' }}
            >
              <div className="edu_form__item" style={{ color: selectRect === `Question${currentIndex}1` ? '#006eff' : 'inherit' }}>
                <MathJax dynamic hideUntilTypeset={"first"}>
                  {MarkItemTitle}
                </MathJax>
              </div>
            </Form.Item>
          )}

          {/* 大题答案列表 - AnswerInfos */}
          <AnswerList 
            answers={AnswerInfos}
            keyPrefix={`markInfo${currentIndex}`}
            onSelect={handleInternalSelect}
            selectRect={selectRect}
            collList={collList}
            setCollList={setCollList}
          />

          {/* 子题目列表 - MarkInfos */}
          <SubQuestionList 
            subMarkInfos={SubMarkInfos}
            questionIdx={currentIndex}
            onSelect={handleInternalSelect}
            selectRect={selectRect}
            collList={collList}
            setCollList={setCollList}
          />
        </div>
      )}
    </div>
  );
}

export default EduMarkCom;
